import { X } from 'lucide-react'

export function DMReplyPreview({ message, onCancel, isDarkMode }) {
  const preview = message.body || `[${message.message_type}]`
  return (
    <div className={`flex items-center gap-3 px-4 py-2 border-t border-l-4 border-l-sfp-orange ${
      isDarkMode ? 'bg-slate-800 border-slate-700' : 'bg-orange-50 border-gray-200'
    }`}>
      <div className="flex-1 min-w-0">
        <p className="text-xs font-semibold text-sfp-orange mb-0.5">Replying to</p>
        <p className={`text-xs truncate ${isDarkMode ? 'text-slate-400' : 'text-gray-600'}`}>{preview}</p>
      </div>
      <button onClick={onCancel} className={`flex-shrink-0 ${isDarkMode ? 'text-slate-400 hover:text-slate-200' : 'text-gray-400 hover:text-gray-600'}`}>
        <X size={14} />
      </button>
    </div>
  )
}
